module.exports = __webpack_public_path__ + "static/media/graphic1.dfcbbc3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Seats/assets/graphic1.svg
// module id = 475
// module chunks = 0